import { Button } from 'antd'
import styled from 'styled-components'

export const MyBtn = styled(Button)<{ $dark?: boolean }>`
  padding: 7px 16px;
  border-width: 2px;
  height: 40px;
  border-radius: 90px;
  box-shadow: none;
  &.ant-btn-lg {
    font-size: 16px;
    height: 48px;
  }
  &.ant-btn-sm {
    font-size: 12px;
    height: 24px;
    padding: 0 12px;
  }
  &.ant-btn-default {
    border-color: ${props =>
      props.$dark ? props.theme['neutral-300'] : props.theme['neutral-600']};
    background: ${props => (props.$dark ? props.theme['neutral-100'] : 'none')};
    color: ${props =>
      props.$dark ? props.theme['neutral-400'] : props.theme['neutral-200']};
    &:hover {
      color: ${props =>
        props.$dark ? props.theme['neutral-500'] : props.theme.primary};
      border-color: ${props =>
        props.$dark ? props.theme['neutral-500'] : props.theme.primary};
    }
    &[disabled] {
      background: none;
      border-color: ${props => props.theme['neutral-600']};
      color: ${props => props.theme['neutral-400']};
    }
  }
  &.ant-btn-circle {
    height: 32px;
    border-radius: 50%;
    padding: 0;
  }
`
